import './base';
import Splide from '@splidejs/splide';
import {
  initSlider
} from './src/photo-slider';
import {
  loadLazyProducts
} from './src/lazy-products';

const mainSlider = document.querySelector('.main-slider__splide');

if (mainSlider) {
  new Splide('.main-slider__splide', {
    // arrowPath: path,
    type: 'loop',
    padding: '2rem',
    arrows: false,
    mediaQuery: 'min',
    classes: {
      arrows: 'splide__arrows main-slider__arrows',
      arrow: 'splide__arrow main-slider__arrow',
      prev: 'splide__arrow--prev main-slider__arrow--prev',
      next: 'splide__arrow--next main-slider__arrow--next',
    },
    breakpoints: {
      '1200': {
        padding: 0,
        cover: true,
        pagination: true,
        arrows: true
      },
    },
  }).mount();
}

const mainDepartments = document.querySelector('.main-departments__splide');

if (mainDepartments) {
  new Splide('.main-departments__splide', {
    fixedWidth: '123px',
    height: '123px',
    gap: '16px',
    pagination: false,
    arrows: false,
    mediaQuery: 'min',
    drag: 'free',
    breakpoints: {
      '768': {
        gap: '24px',
      },
      '1200': {
        fixedWidth: false,
        height: '129px',
        perPage: 6,
      },
      '1649': {
        gap: '29px',
        height: '155px',
        perPage: 7,
      },
    },
  }).mount();
}


const mainSelections = document.querySelector('.main-selections__splide');
if (mainSelections) {
  new Splide('.main-selections__splide', {
    autoWidth: true,
    pagination: false,
    arrows: false,
    mediaQuery: 'min',
    drag: 'free',
    breakpoints: {
      '768': {
        destroy: true,
      }
    },
  }).mount();
}

loadLazyProducts();

initSlider();
